import React from 'react'
import ProgramDetail from '../components/Detail/ProgramDetail'
import useLocationObj from '../hooks/useLocationObj'
import type { ProgramSearchResult } from '../types/api'

const DetailContainer : React.FC<DetailContainerPropType> = ({
  mapLibReady,
  setActiveProgram,
  program,
  zipcode,
  userLocation,
  getUserLocation,
  parentUrl,
}) => {
  const { search, pathname, } = useLocationObj()
  React.useEffect(() => {
    if (getUserLocation && !userLocation) {
      getUserLocation()
    }
  }, [ getUserLocation, userLocation, ])

  if (!search || !search.type || !search.id) {
    return null
  }
  return <ProgramDetail 
    mapLibReady={mapLibReady} 
    setActiveProgram={setActiveProgram}
    userLocation={userLocation}
    programOccupationId={search.id} 
    programType={search.type} 
    program={program}
    pathname={pathname}
    zipcode={zipcode}
    parentUrl={parentUrl}
  />
}

type DetailContainerPropType ={
  mapLibReady      : boolean,
  setActiveProgram : Function,
  program          : ProgramSearchResult,
  zipcode          : string,
  userLocation     : object,
  parentUrl        : string,
  getUserLocation  : Function,
}

export default DetailContainer